<section class="no-results-wrap">
  <img src="assets/images/no-results.svg" alt="no results found"/>
  <div class="result-title">No results found</div>
  <div class="result-info">We couldn’t find what you’re looking for</div>
</section>
